const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the profile selector directive to update user profiles
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('profileSelector', ['AccessProfiles', function(AccessProfiles) {
    return {
      restrict: 'E',
      scope: {
        user: '='
      },
      replace: true,
      template: require('../../../templates/directives/access_profile/profile-selector.html'),
      controller: ['$scope', '$translate', function($scope, $translate) {
          var self = this;
          self.profiles = null;
          self.translations = {};

          self.init = function() {
            AccessProfiles.find({fields: 'name'}).$promise
            .then(function(results) {
              results = results || [];
              self.profiles = results.map(function(item) {
                item.value = item._id;
                return item;
              });

              var defaultVal = $scope.user && $scope.user.access_profile ? 'profiles.na' : 'profiles.chooseAProfile' ;

              $translate([
                defaultVal
              ]).then(function(translations){
                self.translations = translations;
                self.profiles.unshift({name:self.translations[defaultVal] , value: 'remove'});

              });

            });

          };

          self.init();
      }],
      controllerAs: 'selector'
    };
  }
]);